// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireQuestionChoiceOptionBehaviourFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionBehaviour on QuestionnaireQuestionChoiceOptionBehaviour {
  __typename
  metal
  ringStyle
  designStyle
  designFeature
  shape
}
    `;